import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import { t } from '../../localization.js';
import ClanName from '../ClanName/ClanName.js';
import styles from './TooltipClan.module.scss.js';

var TooltipClan = (function (_super) {
    __extends(TooltipClan, _super);
    function TooltipClan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipClan.prototype.render = function () {
        var _a;
        var disbandedMessage = this.props.isDisbanded ? (React.createElement("div", { className: styles.disbandedText }, t('Клан распущен'))) : null;
        return (React.createElement("div", { className: classNames(styles.container, (_a = this.props) === null || _a === void 0 ? void 0 : _a.className) },
            React.createElement("div", null,
                React.createElement(ClanName, { clanTag: this.props.clanTag, clanColor: this.props.clanColor, clanName: this.props.clanName })),
            disbandedMessage));
    };
    return TooltipClan;
}(React.PureComponent));

export { TooltipClan as default };
//# sourceMappingURL=TooltipClan.js.map
